/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import { Popper, Box, Typography, Grow } from '@mui/material'
import PropTypes from 'prop-types'
import { styled } from '@mui/system'

const ArrowBox = styled(Box)(({ theme }) => ({
    position: 'relative',
    backgroundColor: '#fff',
    boxShadow: 'hsl(var(--shadow)) 0px 0px 5px 1px',
    borderRadius: 2,
    maxWidth: 300,
    '&::before': {
        content: '""',
        position: 'absolute',
        top: '5px',
        left: '-10px',
        width: 0,
        height: 0,
        borderTop: '6px solid transparent',
        borderBottom: '6px solid transparent',
        borderRight: '10px solid hsl(var(--primary))'
    }
}))
const MoardMemberDetailsPopper = ({ anchorEl, handleClose, nodeData }) => {
    const open = Boolean(anchorEl)
    if (!nodeData) return null

    return (
        <Popper
            open={open}
            anchorEl={anchorEl}
            sx={{ minWidth: 200 }}
            placement="right-start"
            modifiers={[
                {
                    name: 'offset',
                    options: {
                        offset: [ 0, 10 ]
                    }
                }
            ]}
            transition
        >
            {({ TransitionProps }) => (
                <Grow {...TransitionProps} timeout={350}>
                    <ArrowBox sx={{ p: 2 }}>
                        <Typography className='w-[100%] h-[30px] border-b-2 pb-2 border-primary flex flex-row justify-between items-center' >
                            <p className='text-muted font-bold text-[16px]'>{'Board Member'}</p>
                        </Typography>
                        <Typography className='whitespace-nowrap flex flex-col overflow-hidden overflow-ellipsi' style={{ fontSize: '14px', paddingX: '10px', width: '100%', color: 'hsl(var(--muted))' }} >
                            {nodeData?.boardMembers?.map((data, index) => {
                                return (
                                    <p className='pt-[15px]' key={index}>
                                        {data}
                                    </p>
                                )
                            })}
                        </Typography>
                    </ArrowBox>
                </Grow>
            )}
        </Popper>
    )
}

MoardMemberDetailsPopper.propTypes = {
    anchorEl: PropTypes.any,
    handleClose: PropTypes.func.isRequired,
    nodeData: PropTypes.object
}

export default MoardMemberDetailsPopper
